import axios from 'axios';
import { getStoreState } from '@/redux';
export const API_SERVICE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:8081/api'
    : 'https://app.bhabi.ca/api');

export const api = axios.create({
  baseURL: API_SERVICE_URL,
  headers: {
    // 'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Keep the existing account refresh-on-reload behavior, but never throw
    // away a guest seat or an invitation because a request failed.
    if (
      error.response?.status === 401 &&
      !error.config?.skipAuthRedirect &&
      getStoreState().userReducer.userType !== 'guest'
    ) {
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
